import { render, staticRenderFns } from "./ModalParticipant.vue?vue&type=template&id=f5f2a23e&scoped=true"
import script from "./ModalParticipant.vue?vue&type=script&lang=js"
export * from "./ModalParticipant.vue?vue&type=script&lang=js"
import style0 from "./ModalParticipant.vue?vue&type=style&index=0&id=f5f2a23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f2a23e",
  null
  
)

export default component.exports